@if (detailView === selectedView.order) {
  <app-order-detail
    [order]="order$ | async"
    [serviceOrderForm]="serviceOrderForm$ | async"
    [formAPIData]="formAPIData()"
    [browserSize]="browserSize()"
    [isFileLoading]="isSOFLoading()"
    [areOrdersLoading]="isLoading$ | async"
    (openContactInformationModal)="openContactInformationModal($event)"
  ></app-order-detail>
}

@if (detailView === selectedView.lineItem) {
  <app-line-item-detail
    class="block min-[767px]:p-4"
    [order]="order$ | async"
    [lineItem]="lineItem$ | async"
    [browserSize]="browserSize()"
    [areOrdersLoading]="isLoading$ | async"
    (openContactInformationModal)="openContactInformationModal($event)"
  ></app-line-item-detail>
}
